import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
  NgZone,
} from '@angular/core';

import { CommonModule, Location } from '@angular/common'; // Asegúrate de importar CommonModule
import { TranslateModule } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AlertService } from '../../../../core/services/alert/alert.service';
import { OrdersService } from '../../../../core/services/orders/orders.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { LocalStorageService } from '../../../../core/services/localStorage/local-storage.service';
import { MatInputModule } from '@angular/material/input';
import { Router } from '@angular/router';

@Component({
  selector: 'app-addresses-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    TranslateModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    NgSelectModule,
    FormsModule
  ],
  templateUrl: './addresses-form.component.html',
  styleUrl: './addresses-form.component.css'
})
export class AddressesFormComponent {


  @Output() backButtonClick = new EventEmitter<boolean>();

  addresses = [
    {
      direccion: '328viv Sector R casa 275 275',
      tipo: 'casa',
      dev: true,
      envio: true,
      cp: '3400',
      localidad: 'Corrientes',
      provincia: 'Corrientes',
      nombre: 'JUAN PABLO VALLEJO',
      telefono: '3794000826'
    },
    {
      direccion: 'Avenida Maipu 301',
      tipo: 'comercial',
      cp: '3410',
      localidad: 'Corrientes',
      provincia: 'Corrientes',
      nombre: 'Maximiliano Berta',
      telefono: '3794398400'
    },
    {
      direccion: 'Lavalle 1837',
      tipo: 'casa',
      cp: '3400',
      localidad: 'Corrientes',
      provincia: 'Corrientes',
      nombre: 'Vallejo Juan Pablo',
      telefono: '3794000826'
    },
    {
      direccion: 'Ricardo Guiraldes 460 460',
      tipo: 'casa',
      cp: '3400',
      localidad: 'Corrientes',
      provincia: 'Corrientes',
      nombre: 'Juan Pablo Vallejo',
      telefono: '3794000826'
    }
  ];

  emitBackButtonClick() {
    this.backButtonClick.emit(true);
  }

}
